import styled from 'styled-components';
import { MarkdownViewer } from '@ardoq/markdown';
import { Box } from '@ardoq/layout';
import { Header1 } from '@ardoq/typography';
import { FullWidthStack, SurveyDescription } from './atoms';

// overflow-wrap is inherited, so a long unbroken survey name wraps instead of
// overflowing the title in both the modal and standalone.
const TitleWrapper = styled(Box)`
  min-width: 0;
  overflow-wrap: anywhere;
`;

type TitleAndDescriptionProps = {
  surveyName: string;
  surveyDescription?: string;
  titleAlign: 'left' | 'center';
};

const TitleAndDescription = ({
  surveyName,
  surveyDescription,
  titleAlign,
}: TitleAndDescriptionProps) => (
  <FullWidthStack gap="medium">
    <TitleWrapper>
      <Header1 align={titleAlign}>{surveyName}</Header1>
    </TitleWrapper>
    {surveyDescription ? (
      <SurveyDescription>
        <MarkdownViewer
          content={surveyDescription}
          sanitationLevel="permissive"
        />
      </SurveyDescription>
    ) : null}
  </FullWidthStack>
);

export { TitleAndDescription };
